module.exports = __webpack_public_path__ + "img/explosive_materials.bf1c31c1.svg";